module.exports = __webpack_public_path__ + "img/sampleGraph6.aadcdecf.png";